"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JettonMinter = void 0;
const ton_core_1 = require("ton-core");
const onchainContent_1 = require("../libs/onchainContent");
const request_1 = require("../libs/request");
const getJettonNameState = async (jettonContentUri, options) => {
    let state = {};
    if (jettonContentUri) {
        state = await (0, request_1.requestJson)(jettonContentUri, options);
    }
    if (state.name) {
        state.name = state.name.replace(/\0.*$/g, ""); // remove null bytes
    }
    if (state.decimals && typeof state.decimals == "number") {
        state.decimals = String(state.decimals);
    }
    return state;
};
const getJettonContent = async (jettonContentCell, options) => {
    try {
        const contentSlice = jettonContentCell.beginParse();
        const prefix = contentSlice.loadUint(8);
        if (prefix === onchainContent_1.ONCHAIN_CONTENT_PREFIX) {
            const { uri } = (0, onchainContent_1.readOnchainMetadata)(jettonContentCell, [
                "uri",
            ]);
            const jettonContent = (0, onchainContent_1.readOnchainMetadata)(jettonContentCell, ["name", "description", "image", "symbol", "decimals"]);
            if (uri) {
                const state = await getJettonNameState(uri, options);
                return {
                    ...state,
                    ...jettonContent,
                };
            }
            else {
                return jettonContent;
            }
        }
        else {
            const contentUrl = (0, onchainContent_1.readOffChainMetadata)(contentSlice);
            if (contentUrl) {
                const state = await getJettonNameState(contentUrl.toString("utf8"), options);
                return state;
            }
            else {
                throw new Error("Unexpected jetton metadata content prefix");
            }
        }
    }
    catch (e) {
        return null;
    }
};
class JettonMinter {
    constructor(address, options) {
        this.address = address;
        this.options = options;
    }
    static createFromAddress(address, options) {
        return new JettonMinter(address, options);
    }
    async getJettonData(provider) {
        let res = await provider.get("get_jetton_data", []);
        const totalSupply = res.stack.readBigNumber();
        const isMutable = res.stack.readNumber() === -1;
        let adminAddress = null;
        try {
            adminAddress = res.stack.readAddress();
        }
        catch (e) { }
        const jettonContentCell = res.stack.readCell();
        const jettonWalletCode = res.stack.readCell();
        const jettonContent = await getJettonContent(jettonContentCell, this.options);
        return {
            totalSupply,
            isMutable,
            adminAddress,
            jettonContentCell,
            jettonWalletCode,
            jettonContent,
        };
    }
    async getWalletAddress(provider, wallet) {
        let res = await provider.get("get_wallet_address", [
            { type: "slice", cell: (0, ton_core_1.beginCell)().storeAddress(wallet).endCell() },
        ]);
        return res.stack.readAddress();
    }
}
exports.JettonMinter = JettonMinter;
